export enum LoginPageVariant {
    JetPortal = 'JetPortal',
    LoyaltyScheme = 'LoyaltyScheme'
}
